import React from 'react';
import { IconArrowRight } from '../Icons';
//import { StaticImage } from 'gatsby-plugin-image';
import './GridCard.scss';

import BoardImage from '../../assets/GridCard/boards.svg';
import CloudImage from '../../assets/cloud.svg';
import IdeImage from '../../assets/GridCard/ide.svg';
import CodeImage from '../../assets/GridCard/code.svg';

export interface GridCardProps {
  title: string;
  description: string;
  linkText: string;
  link: string;
  img: string;
}

const getImage = (img) => {
  switch (img) {
    case 'boards':
      return <img src={BoardImage} alt="BoardImage" className="grid-card__image--item boards" />;
    case 'cloud':
      return <img src={CloudImage} alt="CloudImage" className="grid-card__image--item ide1" />;
    case 'ide':
      return <img src={IdeImage} alt="IdeImage" className="grid-card__image--item ide2" />;
    case 'code':
      return <img src={CodeImage} alt="CodeImage" className="grid-card__image--item code" />;
    default:
      break;
  }
};

export default function GridCard(props: GridCardProps): React.ReactElement {
  const { title, description, linkText, link, img } = props;

  return (
    <a href={link} className="grid-card">
      <div className="grid-card__content">
        <h3>{title}</h3>
        <p>{description}</p>
        <span>
          {linkText} <IconArrowRight className="grid-card__icon" />
        </span>
        <div className="grid-card__space" />
      </div>
      <div className="grid-card__image">{getImage(img)}</div>
    </a>
  );
}
